import x from "react";
import { l as ae } from "./react-easy-swipe-5c12dd2c.js";
import { c as ce } from "./classnames-0d222af1.js";
var de = {}, q = {}, W = {};
Object.defineProperty(W, "__esModule", {
  value: !0
});
W.default = void 0;
var R = pe(ce);
function pe(t) {
  return t && t.__esModule ? t : { default: t };
}
function me(t, r, n) {
  return r in t ? Object.defineProperty(t, r, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[r] = n, t;
}
var he = {
  ROOT: function(r) {
    return (0, R.default)(me({
      "carousel-root": !0
    }, r || "", !!r));
  },
  CAROUSEL: function(r) {
    return (0, R.default)({
      carousel: !0,
      "carousel-slider": r
    });
  },
  WRAPPER: function(r, n) {
    return (0, R.default)({
      "thumbs-wrapper": !r,
      "slider-wrapper": r,
      "axis-horizontal": n === "horizontal",
      "axis-vertical": n !== "horizontal"
    });
  },
  SLIDER: function(r, n) {
    return (0, R.default)({
      thumbs: !r,
      slider: r,
      animated: !n
    });
  },
  ITEM: function(r, n, i) {
    return (0, R.default)({
      thumb: !r,
      slide: r,
      selected: n,
      previous: i
    });
  },
  ARROW_PREV: function(r) {
    return (0, R.default)({
      "control-arrow control-prev": !0,
      "control-disabled": r
    });
  },
  ARROW_NEXT: function(r) {
    return (0, R.default)({
      "control-arrow control-next": !0,
      "control-disabled": r
    });
  },
  DOT: function(r) {
    return (0, R.default)({
      dot: !0,
      selected: r
    });
  }
};
W.default = he;
var k = {}, B = {};
Object.defineProperty(B, "__esModule", {
  value: !0
});
B.outerWidth = void 0;
var ve = function(r) {
  var n = r.offsetWidth, i = getComputedStyle(r);
  return n += parseInt(i.marginLeft) + parseInt(i.marginRight), n;
};
B.outerWidth = ve;
var C = {};
Object.defineProperty(C, "__esModule", {
  value: !0
});
C.default = void 0;
var ye = function(r, n, i) {
  var e = r === 0 ? r : r + n, a = i === "horizontal" ? [e, 0, 0] : [0, e, 0], s = "translate3d", o = "(" + a.join(",") + ")";
  return s + o;
};
C.default = ye;
var D = {};
Object.defineProperty(D, "__esModule", {
  value: !0
});
D.default = void 0;
var Se = function() {
  return window;
};
D.default = Se;
Object.defineProperty(k, "__esModule", {
  value: !0
});
k.default = void 0;
var b = ge(x), T = j(W), we = B, ee = j(C), be = j(ae), H = j(D);
function j(t) {
  return t && t.__esModule ? t : { default: t };
}
function se() {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap();
  return se = function() {
    return t;
  }, t;
}
function ge(t) {
  if (t && t.__esModule)
    return t;
  if (t === null || M(t) !== "object" && typeof t != "function")
    return { default: t };
  var r = se();
  if (r && r.has(t))
    return r.get(t);
  var n = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var e in t)
    if (Object.prototype.hasOwnProperty.call(t, e)) {
      var a = i ? Object.getOwnPropertyDescriptor(t, e) : null;
      a && (a.get || a.set) ? Object.defineProperty(n, e, a) : n[e] = t[e];
    }
  return n.default = t, r && r.set(t, n), n;
}
function M(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? M = function(n) {
    return typeof n;
  } : M = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, M(t);
}
function X() {
  return X = Object.assign || function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, X.apply(this, arguments);
}
function Pe(t, r) {
  if (!(t instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function te(t, r) {
  for (var n = 0; n < r.length; n++) {
    var i = r[n];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}
function _e(t, r, n) {
  return r && te(t.prototype, r), n && te(t, n), t;
}
function Oe(t, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(r && r.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), r && G(t, r);
}
function G(t, r) {
  return G = Object.setPrototypeOf || function(i, e) {
    return i.__proto__ = e, i;
  }, G(t, r);
}
function Ie(t) {
  var r = Te();
  return function() {
    var i = F(t), e;
    if (r) {
      var a = F(this).constructor;
      e = Reflect.construct(i, arguments, a);
    } else
      e = i.apply(this, arguments);
    return Re(this, e);
  };
}
function Re(t, r) {
  return r && (M(r) === "object" || typeof r == "function") ? r : S(t);
}
function S(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Te() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function F(t) {
  return F = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, F(t);
}
function y(t, r, n) {
  return r in t ? Object.defineProperty(t, r, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[r] = n, t;
}
var Ee = function(r) {
  return r.hasOwnProperty("key");
}, Y = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var r = Ie(n);
  function n(i) {
    var e;
    return Pe(this, n), e = r.call(this, i), y(S(e), "itemsWrapperRef", void 0), y(S(e), "itemsListRef", void 0), y(S(e), "thumbsRef", void 0), y(S(e), "setItemsWrapperRef", function(a) {
      e.itemsWrapperRef = a;
    }), y(S(e), "setItemsListRef", function(a) {
      e.itemsListRef = a;
    }), y(S(e), "setThumbsRef", function(a, s) {
      e.thumbsRef || (e.thumbsRef = []), e.thumbsRef[s] = a;
    }), y(S(e), "updateSizes", function() {
      if (!(!e.props.children || !e.itemsWrapperRef || !e.thumbsRef)) {
        var a = b.Children.count(e.props.children), s = e.itemsWrapperRef.clientWidth, o = e.props.thumbWidth ? e.props.thumbWidth : (0, we.outerWidth)(e.thumbsRef[0]), u = Math.floor(s / o), c = u < a, d = c ? a - u : 0;
        e.setState(function(m, v) {
          return {
            itemSize: o,
            visibleItems: u,
            firstItem: c ? e.getFirstItem(v.selectedItem) : 0,
            lastPosition: d,
            showArrows: c
          };
        });
      }
    }), y(S(e), "handleClickItem", function(a, s, o) {
      if (!Ee(o) || o.key === "Enter") {
        var u = e.props.onSelectItem;
        typeof u == "function" && u(a, s);
      }
    }), y(S(e), "onSwipeStart", function() {
      e.setState({
        swiping: !0
      });
    }), y(S(e), "onSwipeEnd", function() {
      e.setState({
        swiping: !1
      });
    }), y(S(e), "onSwipeMove", function(a) {
      var s = a.x;
      if (!e.state.itemSize || !e.itemsWrapperRef || !e.state.visibleItems)
        return !1;
      var o = 0, u = b.Children.count(e.props.children), c = -(e.state.firstItem * 100) / e.state.visibleItems, d = Math.max(u - e.state.visibleItems, 0), m = -d * 100 / e.state.visibleItems;
      c === o && s > 0 && (s = 0), c === m && s < 0 && (s = 0);
      var v = e.itemsWrapperRef.clientWidth, h = c + 100 / (v / s);
      return e.itemsListRef && ["WebkitTransform", "MozTransform", "MsTransform", "OTransform", "transform", "msTransform"].forEach(function(O) {
        e.itemsListRef.style[O] = (0, ee.default)(h, "%", e.props.axis);
      }), !0;
    }), y(S(e), "slideRight", function(a) {
      e.moveTo(e.state.firstItem - (typeof a == "number" ? a : 1));
    }), y(S(e), "slideLeft", function(a) {
      e.moveTo(e.state.firstItem + (typeof a == "number" ? a : 1));
    }), y(S(e), "moveTo", function(a) {
      a = a < 0 ? 0 : a, a = a >= e.state.lastPosition ? e.state.lastPosition : a, e.setState({
        firstItem: a
      });
    }), e.state = {
      selectedItem: i.selectedItem,
      swiping: !1,
      showArrows: !1,
      firstItem: 0,
      visibleItems: 0,
      lastPosition: 0
    }, e;
  }
  return _e(n, [{
    key: "componentDidMount",
    value: function() {
      this.setupThumbs();
    }
  }, {
    key: "componentDidUpdate",
    value: function(e) {
      this.props.selectedItem !== this.state.selectedItem && this.setState({
        selectedItem: this.props.selectedItem,
        firstItem: this.getFirstItem(this.props.selectedItem)
      }), this.props.children !== e.children && this.updateSizes();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroyThumbs();
    }
  }, {
    key: "setupThumbs",
    value: function() {
      (0, H.default)().addEventListener("resize", this.updateSizes), (0, H.default)().addEventListener("DOMContentLoaded", this.updateSizes), this.updateSizes();
    }
  }, {
    key: "destroyThumbs",
    value: function() {
      (0, H.default)().removeEventListener("resize", this.updateSizes), (0, H.default)().removeEventListener("DOMContentLoaded", this.updateSizes);
    }
  }, {
    key: "getFirstItem",
    value: function(e) {
      var a = e;
      return e >= this.state.lastPosition && (a = this.state.lastPosition), e < this.state.firstItem + this.state.visibleItems && (a = this.state.firstItem), e < this.state.firstItem && (a = e), a;
    }
  }, {
    key: "renderItems",
    value: function() {
      var e = this;
      return this.props.children.map(function(a, s) {
        var o = T.default.ITEM(!1, s === e.state.selectedItem), u = {
          key: s,
          ref: function(d) {
            return e.setThumbsRef(d, s);
          },
          className: o,
          onClick: e.handleClickItem.bind(e, s, e.props.children[s]),
          onKeyDown: e.handleClickItem.bind(e, s, e.props.children[s]),
          "aria-label": "".concat(e.props.labels.item, " ").concat(s + 1),
          style: {
            width: e.props.thumbWidth
          }
        };
        return /* @__PURE__ */ b.default.createElement("li", X({}, u, {
          role: "button",
          tabIndex: 0
        }), a);
      });
    }
  }, {
    key: "render",
    value: function() {
      var e = this;
      if (!this.props.children)
        return null;
      var a = b.Children.count(this.props.children) > 1, s = this.state.showArrows && this.state.firstItem > 0, o = this.state.showArrows && this.state.firstItem < this.state.lastPosition, u = {}, c = -this.state.firstItem * (this.state.itemSize || 0), d = (0, ee.default)(c, "px", this.props.axis), m = this.props.transitionTime + "ms";
      return u = {
        WebkitTransform: d,
        MozTransform: d,
        MsTransform: d,
        OTransform: d,
        transform: d,
        msTransform: d,
        WebkitTransitionDuration: m,
        MozTransitionDuration: m,
        MsTransitionDuration: m,
        OTransitionDuration: m,
        transitionDuration: m,
        msTransitionDuration: m
      }, /* @__PURE__ */ b.default.createElement("div", {
        className: T.default.CAROUSEL(!1)
      }, /* @__PURE__ */ b.default.createElement("div", {
        className: T.default.WRAPPER(!1),
        ref: this.setItemsWrapperRef
      }, /* @__PURE__ */ b.default.createElement("button", {
        type: "button",
        className: T.default.ARROW_PREV(!s),
        onClick: function() {
          return e.slideRight();
        },
        "aria-label": this.props.labels.leftArrow
      }), a ? /* @__PURE__ */ b.default.createElement(be.default, {
        tagName: "ul",
        className: T.default.SLIDER(!1, this.state.swiping),
        onSwipeLeft: this.slideLeft,
        onSwipeRight: this.slideRight,
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: u,
        innerRef: this.setItemsListRef,
        allowMouseEvents: this.props.emulateTouch
      }, this.renderItems()) : /* @__PURE__ */ b.default.createElement("ul", {
        className: T.default.SLIDER(!1, this.state.swiping),
        ref: function(h) {
          return e.setItemsListRef(h);
        },
        style: u
      }, this.renderItems()), /* @__PURE__ */ b.default.createElement("button", {
        type: "button",
        className: T.default.ARROW_NEXT(!o),
        onClick: function() {
          return e.slideLeft();
        },
        "aria-label": this.props.labels.rightArrow
      })));
    }
  }]), n;
}(b.Component);
k.default = Y;
y(Y, "displayName", "Thumbs");
y(Y, "defaultProps", {
  axis: "horizontal",
  labels: {
    leftArrow: "previous slide / item",
    rightArrow: "next slide / item",
    item: "slide item"
  },
  selectedItem: 0,
  thumbWidth: 80,
  transitionTime: 350
});
var V = {};
Object.defineProperty(V, "__esModule", {
  value: !0
});
V.default = void 0;
var Ce = function() {
  return document;
};
V.default = Ce;
var w = {};
Object.defineProperty(w, "__esModule", {
  value: !0
});
w.setPosition = w.getPosition = w.isKeyboardEvent = w.defaultStatusFormatter = w.noop = void 0;
var Le = x, Me = Ae(C);
function Ae(t) {
  return t && t.__esModule ? t : { default: t };
}
var We = function() {
};
w.noop = We;
var ke = function(r, n) {
  return "".concat(r, " of ").concat(n);
};
w.defaultStatusFormatter = ke;
var De = function(r) {
  return r ? r.hasOwnProperty("key") : !1;
};
w.isKeyboardEvent = De;
var ze = function(r, n) {
  if (n.infiniteLoop && ++r, r === 0)
    return 0;
  var i = Le.Children.count(n.children);
  if (n.centerMode && n.axis === "horizontal") {
    var e = -r * n.centerSlidePercentage, a = i - 1;
    return r && (r !== a || n.infiniteLoop) ? e += (100 - n.centerSlidePercentage) / 2 : r === a && (e += 100 - n.centerSlidePercentage), e;
  }
  return -r * 100;
};
w.getPosition = ze;
var He = function(r, n) {
  var i = {};
  return ["WebkitTransform", "MozTransform", "MsTransform", "OTransform", "transform", "msTransform"].forEach(function(e) {
    i[e] = (0, Me.default)(r, "%", n);
  }), i;
};
w.setPosition = He;
var P = {};
Object.defineProperty(P, "__esModule", {
  value: !0
});
P.fadeAnimationHandler = P.slideStopSwipingHandler = P.slideSwipeAnimationHandler = P.slideAnimationHandler = void 0;
var oe = x, Ne = $e(C), _ = w;
function $e(t) {
  return t && t.__esModule ? t : { default: t };
}
function re(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    r && (i = i.filter(function(e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function E(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? re(Object(n), !0).forEach(function(i) {
      Fe(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : re(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
function Fe(t, r, n) {
  return r in t ? Object.defineProperty(t, r, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[r] = n, t;
}
var Ke = function(r, n) {
  var i = {}, e = n.selectedItem, a = e, s = oe.Children.count(r.children) - 1, o = r.infiniteLoop && (e < 0 || e > s);
  if (o)
    return a < 0 ? r.centerMode && r.centerSlidePercentage && r.axis === "horizontal" ? i.itemListStyle = (0, _.setPosition)(-(s + 2) * r.centerSlidePercentage - (100 - r.centerSlidePercentage) / 2, r.axis) : i.itemListStyle = (0, _.setPosition)(-(s + 2) * 100, r.axis) : a > s && (i.itemListStyle = (0, _.setPosition)(0, r.axis)), i;
  var u = (0, _.getPosition)(e, r), c = (0, Ne.default)(u, "%", r.axis), d = r.transitionTime + "ms";
  return i.itemListStyle = {
    WebkitTransform: c,
    msTransform: c,
    OTransform: c,
    transform: c
  }, n.swiping || (i.itemListStyle = E(E({}, i.itemListStyle), {}, {
    WebkitTransitionDuration: d,
    MozTransitionDuration: d,
    OTransitionDuration: d,
    transitionDuration: d,
    msTransitionDuration: d
  })), i;
};
P.slideAnimationHandler = Ke;
var Ue = function(r, n, i, e) {
  var a = {}, s = n.axis === "horizontal", o = oe.Children.count(n.children), u = 0, c = (0, _.getPosition)(i.selectedItem, n), d = n.infiniteLoop ? (0, _.getPosition)(o - 1, n) - 100 : (0, _.getPosition)(o - 1, n), m = s ? r.x : r.y, v = m;
  c === u && m > 0 && (v = 0), c === d && m < 0 && (v = 0);
  var h = c + 100 / (i.itemSize / v), O = Math.abs(m) > n.swipeScrollTolerance;
  return n.infiniteLoop && O && (i.selectedItem === 0 && h > -100 ? h -= o * 100 : i.selectedItem === o - 1 && h < -o * 100 && (h += o * 100)), (!n.preventMovementUntilSwipeScrollTolerance || O || i.swipeMovementStarted) && (i.swipeMovementStarted || e({
    swipeMovementStarted: !0
  }), a.itemListStyle = (0, _.setPosition)(h, n.axis)), O && !i.cancelClick && e({
    cancelClick: !0
  }), a;
};
P.slideSwipeAnimationHandler = Ue;
var xe = function(r, n) {
  var i = (0, _.getPosition)(n.selectedItem, r), e = (0, _.setPosition)(i, r.axis);
  return {
    itemListStyle: e
  };
};
P.slideStopSwipingHandler = xe;
var qe = function(r, n) {
  var i = r.transitionTime + "ms", e = "ease-in-out", a = {
    position: "absolute",
    display: "block",
    zIndex: -2,
    minHeight: "100%",
    opacity: 0,
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    transitionTimingFunction: e,
    msTransitionTimingFunction: e,
    MozTransitionTimingFunction: e,
    WebkitTransitionTimingFunction: e,
    OTransitionTimingFunction: e
  };
  return n.swiping || (a = E(E({}, a), {}, {
    WebkitTransitionDuration: i,
    MozTransitionDuration: i,
    OTransitionDuration: i,
    transitionDuration: i,
    msTransitionDuration: i
  })), {
    slideStyle: a,
    selectedStyle: E(E({}, a), {}, {
      opacity: 1,
      position: "relative"
    }),
    prevStyle: E({}, a)
  };
};
P.fadeAnimationHandler = qe;
Object.defineProperty(q, "__esModule", {
  value: !0
});
q.default = void 0;
var p = Ve(x), Be = z(ae), I = z(W), je = z(k), N = z(V), $ = z(D), L = w, K = P;
function z(t) {
  return t && t.__esModule ? t : { default: t };
}
function ue() {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap();
  return ue = function() {
    return t;
  }, t;
}
function Ve(t) {
  if (t && t.__esModule)
    return t;
  if (t === null || A(t) !== "object" && typeof t != "function")
    return { default: t };
  var r = ue();
  if (r && r.has(t))
    return r.get(t);
  var n = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var e in t)
    if (Object.prototype.hasOwnProperty.call(t, e)) {
      var a = i ? Object.getOwnPropertyDescriptor(t, e) : null;
      a && (a.get || a.set) ? Object.defineProperty(n, e, a) : n[e] = t[e];
    }
  return n.default = t, r && r.set(t, n), n;
}
function A(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? A = function(n) {
    return typeof n;
  } : A = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, A(t);
}
function J() {
  return J = Object.assign || function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, J.apply(this, arguments);
}
function ne(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    r && (i = i.filter(function(e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function g(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ne(Object(n), !0).forEach(function(i) {
      l(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ne(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
function Xe(t, r) {
  if (!(t instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function ie(t, r) {
  for (var n = 0; n < r.length; n++) {
    var i = r[n];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}
function Ge(t, r, n) {
  return r && ie(t.prototype, r), n && ie(t, n), t;
}
function Je(t, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(r && r.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), r && Q(t, r);
}
function Q(t, r) {
  return Q = Object.setPrototypeOf || function(i, e) {
    return i.__proto__ = e, i;
  }, Q(t, r);
}
function Qe(t) {
  var r = Ze();
  return function() {
    var i = U(t), e;
    if (r) {
      var a = U(this).constructor;
      e = Reflect.construct(i, arguments, a);
    } else
      e = i.apply(this, arguments);
    return Ye(this, e);
  };
}
function Ye(t, r) {
  return r && (A(r) === "object" || typeof r == "function") ? r : f(t);
}
function f(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Ze() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function U(t) {
  return U = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, U(t);
}
function l(t, r, n) {
  return r in t ? Object.defineProperty(t, r, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[r] = n, t;
}
var Z = /* @__PURE__ */ function(t) {
  Je(n, t);
  var r = Qe(n);
  function n(i) {
    var e;
    Xe(this, n), e = r.call(this, i), l(f(e), "thumbsRef", void 0), l(f(e), "carouselWrapperRef", void 0), l(f(e), "listRef", void 0), l(f(e), "itemsRef", void 0), l(f(e), "timer", void 0), l(f(e), "animationHandler", void 0), l(f(e), "setThumbsRef", function(s) {
      e.thumbsRef = s;
    }), l(f(e), "setCarouselWrapperRef", function(s) {
      e.carouselWrapperRef = s;
    }), l(f(e), "setListRef", function(s) {
      e.listRef = s;
    }), l(f(e), "setItemsRef", function(s, o) {
      e.itemsRef || (e.itemsRef = []), e.itemsRef[o] = s;
    }), l(f(e), "autoPlay", function() {
      p.Children.count(e.props.children) <= 1 || (e.clearAutoPlay(), e.props.autoPlay && (e.timer = setTimeout(function() {
        e.increment();
      }, e.props.interval)));
    }), l(f(e), "clearAutoPlay", function() {
      e.timer && clearTimeout(e.timer);
    }), l(f(e), "resetAutoPlay", function() {
      e.clearAutoPlay(), e.autoPlay();
    }), l(f(e), "stopOnHover", function() {
      e.setState({
        isMouseEntered: !0
      }, e.clearAutoPlay);
    }), l(f(e), "startOnLeave", function() {
      e.setState({
        isMouseEntered: !1
      }, e.autoPlay);
    }), l(f(e), "isFocusWithinTheCarousel", function() {
      return e.carouselWrapperRef ? !!((0, N.default)().activeElement === e.carouselWrapperRef || e.carouselWrapperRef.contains((0, N.default)().activeElement)) : !1;
    }), l(f(e), "navigateWithKeyboard", function(s) {
      if (e.isFocusWithinTheCarousel()) {
        var o = e.props.axis, u = o === "horizontal", c = {
          ArrowUp: 38,
          ArrowRight: 39,
          ArrowDown: 40,
          ArrowLeft: 37
        }, d = u ? c.ArrowRight : c.ArrowDown, m = u ? c.ArrowLeft : c.ArrowUp;
        d === s.keyCode ? e.increment() : m === s.keyCode && e.decrement();
      }
    }), l(f(e), "updateSizes", function() {
      if (!(!e.state.initialized || !e.itemsRef || e.itemsRef.length === 0)) {
        var s = e.props.axis === "horizontal", o = e.itemsRef[0];
        if (o) {
          var u = s ? o.clientWidth : o.clientHeight;
          e.setState({
            itemSize: u
          }), e.thumbsRef && e.thumbsRef.updateSizes();
        }
      }
    }), l(f(e), "setMountState", function() {
      e.setState({
        hasMount: !0
      }), e.updateSizes();
    }), l(f(e), "handleClickItem", function(s, o) {
      if (p.Children.count(e.props.children) !== 0) {
        if (e.state.cancelClick) {
          e.setState({
            cancelClick: !1
          });
          return;
        }
        e.props.onClickItem(s, o), s !== e.state.selectedItem && e.setState({
          selectedItem: s
        });
      }
    }), l(f(e), "handleOnChange", function(s, o) {
      p.Children.count(e.props.children) <= 1 || e.props.onChange(s, o);
    }), l(f(e), "handleClickThumb", function(s, o) {
      e.props.onClickThumb(s, o), e.moveTo(s);
    }), l(f(e), "onSwipeStart", function(s) {
      e.setState({
        swiping: !0
      }), e.props.onSwipeStart(s);
    }), l(f(e), "onSwipeEnd", function(s) {
      e.setState({
        swiping: !1,
        cancelClick: !1,
        swipeMovementStarted: !1
      }), e.props.onSwipeEnd(s), e.clearAutoPlay(), e.state.autoPlay && e.autoPlay();
    }), l(f(e), "onSwipeMove", function(s, o) {
      e.props.onSwipeMove(o);
      var u = e.props.swipeAnimationHandler(s, e.props, e.state, e.setState.bind(f(e)));
      return e.setState(g({}, u)), !!Object.keys(u).length;
    }), l(f(e), "decrement", function() {
      var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
      e.moveTo(e.state.selectedItem - (typeof s == "number" ? s : 1));
    }), l(f(e), "increment", function() {
      var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
      e.moveTo(e.state.selectedItem + (typeof s == "number" ? s : 1));
    }), l(f(e), "moveTo", function(s) {
      if (typeof s == "number") {
        var o = p.Children.count(e.props.children) - 1;
        s < 0 && (s = e.props.infiniteLoop ? o : 0), s > o && (s = e.props.infiniteLoop ? 0 : o), e.selectItem({
          // if it's not a slider, we don't need to set position here
          selectedItem: s
        }), e.state.autoPlay && e.state.isMouseEntered === !1 && e.resetAutoPlay();
      }
    }), l(f(e), "onClickNext", function() {
      e.increment(1);
    }), l(f(e), "onClickPrev", function() {
      e.decrement(1);
    }), l(f(e), "onSwipeForward", function() {
      e.increment(1), e.props.emulateTouch && e.setState({
        cancelClick: !0
      });
    }), l(f(e), "onSwipeBackwards", function() {
      e.decrement(1), e.props.emulateTouch && e.setState({
        cancelClick: !0
      });
    }), l(f(e), "changeItem", function(s) {
      return function(o) {
        (!(0, L.isKeyboardEvent)(o) || o.key === "Enter") && e.moveTo(s);
      };
    }), l(f(e), "selectItem", function(s) {
      e.setState(g({
        previousItem: e.state.selectedItem
      }, s), function() {
        e.setState(e.animationHandler(e.props, e.state));
      }), e.handleOnChange(s.selectedItem, p.Children.toArray(e.props.children)[s.selectedItem]);
    }), l(f(e), "getInitialImage", function() {
      var s = e.props.selectedItem, o = e.itemsRef && e.itemsRef[s], u = o && o.getElementsByTagName("img") || [];
      return u[0];
    }), l(f(e), "getVariableItemHeight", function(s) {
      var o = e.itemsRef && e.itemsRef[s];
      if (e.state.hasMount && o && o.children.length) {
        var u = o.children[0].getElementsByTagName("img") || [];
        if (u.length > 0) {
          var c = u[0];
          if (!c.complete) {
            var d = function h() {
              e.forceUpdate(), c.removeEventListener("load", h);
            };
            c.addEventListener("load", d);
          }
        }
        var m = u[0] || o.children[0], v = m.clientHeight;
        return v > 0 ? v : null;
      }
      return null;
    });
    var a = {
      initialized: !1,
      previousItem: i.selectedItem,
      selectedItem: i.selectedItem,
      hasMount: !1,
      isMouseEntered: !1,
      autoPlay: i.autoPlay,
      swiping: !1,
      swipeMovementStarted: !1,
      cancelClick: !1,
      itemSize: 1,
      itemListStyle: {},
      slideStyle: {},
      selectedStyle: {},
      prevStyle: {}
    };
    return e.animationHandler = typeof i.animationHandler == "function" && i.animationHandler || i.animationHandler === "fade" && K.fadeAnimationHandler || K.slideAnimationHandler, e.state = g(g({}, a), e.animationHandler(i, a)), e;
  }
  return Ge(n, [{
    key: "componentDidMount",
    value: function() {
      this.props.children && this.setupCarousel();
    }
  }, {
    key: "componentDidUpdate",
    value: function(e, a) {
      !e.children && this.props.children && !this.state.initialized && this.setupCarousel(), !e.autoFocus && this.props.autoFocus && this.forceFocus(), a.swiping && !this.state.swiping && this.setState(g({}, this.props.stopSwipingHandler(this.props, this.state))), (e.selectedItem !== this.props.selectedItem || e.centerMode !== this.props.centerMode) && (this.updateSizes(), this.moveTo(this.props.selectedItem)), e.autoPlay !== this.props.autoPlay && (this.props.autoPlay ? this.setupAutoPlay() : this.destroyAutoPlay(), this.setState({
        autoPlay: this.props.autoPlay
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroyCarousel();
    }
  }, {
    key: "setupCarousel",
    value: function() {
      var e = this;
      this.bindEvents(), this.state.autoPlay && p.Children.count(this.props.children) > 1 && this.setupAutoPlay(), this.props.autoFocus && this.forceFocus(), this.setState({
        initialized: !0
      }, function() {
        var a = e.getInitialImage();
        a && !a.complete ? a.addEventListener("load", e.setMountState) : e.setMountState();
      });
    }
  }, {
    key: "destroyCarousel",
    value: function() {
      this.state.initialized && (this.unbindEvents(), this.destroyAutoPlay());
    }
  }, {
    key: "setupAutoPlay",
    value: function() {
      this.autoPlay();
      var e = this.carouselWrapperRef;
      this.props.stopOnHover && e && (e.addEventListener("mouseenter", this.stopOnHover), e.addEventListener("mouseleave", this.startOnLeave));
    }
  }, {
    key: "destroyAutoPlay",
    value: function() {
      this.clearAutoPlay();
      var e = this.carouselWrapperRef;
      this.props.stopOnHover && e && (e.removeEventListener("mouseenter", this.stopOnHover), e.removeEventListener("mouseleave", this.startOnLeave));
    }
  }, {
    key: "bindEvents",
    value: function() {
      (0, $.default)().addEventListener("resize", this.updateSizes), (0, $.default)().addEventListener("DOMContentLoaded", this.updateSizes), this.props.useKeyboardArrows && (0, N.default)().addEventListener("keydown", this.navigateWithKeyboard);
    }
  }, {
    key: "unbindEvents",
    value: function() {
      (0, $.default)().removeEventListener("resize", this.updateSizes), (0, $.default)().removeEventListener("DOMContentLoaded", this.updateSizes);
      var e = this.getInitialImage();
      e && e.removeEventListener("load", this.setMountState), this.props.useKeyboardArrows && (0, N.default)().removeEventListener("keydown", this.navigateWithKeyboard);
    }
  }, {
    key: "forceFocus",
    value: function() {
      var e;
      (e = this.carouselWrapperRef) === null || e === void 0 || e.focus();
    }
  }, {
    key: "renderItems",
    value: function(e) {
      var a = this;
      return this.props.children ? p.Children.map(this.props.children, function(s, o) {
        var u = o === a.state.selectedItem, c = o === a.state.previousItem, d = u && a.state.selectedStyle || c && a.state.prevStyle || a.state.slideStyle || {};
        a.props.centerMode && a.props.axis === "horizontal" && (d = g(g({}, d), {}, {
          minWidth: a.props.centerSlidePercentage + "%"
        })), a.state.swiping && a.state.swipeMovementStarted && (d = g(g({}, d), {}, {
          pointerEvents: "none"
        }));
        var m = {
          ref: function(h) {
            return a.setItemsRef(h, o);
          },
          key: "itemKey" + o + (e ? "clone" : ""),
          className: I.default.ITEM(!0, o === a.state.selectedItem, o === a.state.previousItem),
          onClick: a.handleClickItem.bind(a, o, s),
          style: d
        };
        return /* @__PURE__ */ p.default.createElement("li", m, a.props.renderItem(s, {
          isSelected: o === a.state.selectedItem,
          isPrevious: o === a.state.previousItem
        }));
      }) : [];
    }
  }, {
    key: "renderControls",
    value: function() {
      var e = this, a = this.props, s = a.showIndicators, o = a.labels, u = a.renderIndicator, c = a.children;
      return s ? /* @__PURE__ */ p.default.createElement("ul", {
        className: "control-dots"
      }, p.Children.map(c, function(d, m) {
        return u && u(e.changeItem(m), m === e.state.selectedItem, m, o.item);
      })) : null;
    }
  }, {
    key: "renderStatus",
    value: function() {
      return this.props.showStatus ? /* @__PURE__ */ p.default.createElement("p", {
        className: "carousel-status"
      }, this.props.statusFormatter(this.state.selectedItem + 1, p.Children.count(this.props.children))) : null;
    }
  }, {
    key: "renderThumbs",
    value: function() {
      return !this.props.showThumbs || !this.props.children || p.Children.count(this.props.children) === 0 ? null : /* @__PURE__ */ p.default.createElement(je.default, {
        ref: this.setThumbsRef,
        onSelectItem: this.handleClickThumb,
        selectedItem: this.state.selectedItem,
        transitionTime: this.props.transitionTime,
        thumbWidth: this.props.thumbWidth,
        labels: this.props.labels,
        emulateTouch: this.props.emulateTouch
      }, this.props.renderThumbs(this.props.children));
    }
  }, {
    key: "render",
    value: function() {
      var e = this;
      if (!this.props.children || p.Children.count(this.props.children) === 0)
        return null;
      var a = this.props.swipeable && p.Children.count(this.props.children) > 1, s = this.props.axis === "horizontal", o = this.props.showArrows && p.Children.count(this.props.children) > 1, u = o && (this.state.selectedItem > 0 || this.props.infiniteLoop) || !1, c = o && (this.state.selectedItem < p.Children.count(this.props.children) - 1 || this.props.infiniteLoop) || !1, d = this.renderItems(!0), m = d.shift(), v = d.pop(), h = {
        className: I.default.SLIDER(!0, this.state.swiping),
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: this.state.itemListStyle,
        tolerance: this.props.swipeScrollTolerance
      }, O = {};
      if (s) {
        if (h.onSwipeLeft = this.onSwipeForward, h.onSwipeRight = this.onSwipeBackwards, this.props.dynamicHeight) {
          var le = this.getVariableItemHeight(this.state.selectedItem);
          O.height = le || "auto";
        }
      } else
        h.onSwipeUp = this.props.verticalSwipe === "natural" ? this.onSwipeBackwards : this.onSwipeForward, h.onSwipeDown = this.props.verticalSwipe === "natural" ? this.onSwipeForward : this.onSwipeBackwards, h.style = g(g({}, h.style), {}, {
          height: this.state.itemSize
        }), O.height = this.state.itemSize;
      return /* @__PURE__ */ p.default.createElement("div", {
        "aria-label": this.props.ariaLabel,
        className: I.default.ROOT(this.props.className),
        ref: this.setCarouselWrapperRef,
        tabIndex: this.props.useKeyboardArrows ? 0 : void 0
      }, /* @__PURE__ */ p.default.createElement("div", {
        className: I.default.CAROUSEL(!0),
        style: {
          width: this.props.width
        }
      }, this.renderControls(), this.props.renderArrowPrev(this.onClickPrev, u, this.props.labels.leftArrow), /* @__PURE__ */ p.default.createElement("div", {
        className: I.default.WRAPPER(!0, this.props.axis),
        style: O
      }, a ? /* @__PURE__ */ p.default.createElement(Be.default, J({
        tagName: "ul",
        innerRef: this.setListRef
      }, h, {
        allowMouseEvents: this.props.emulateTouch
      }), this.props.infiniteLoop && v, this.renderItems(), this.props.infiniteLoop && m) : /* @__PURE__ */ p.default.createElement("ul", {
        className: I.default.SLIDER(!0, this.state.swiping),
        ref: function(fe) {
          return e.setListRef(fe);
        },
        style: this.state.itemListStyle || {}
      }, this.props.infiniteLoop && v, this.renderItems(), this.props.infiniteLoop && m)), this.props.renderArrowNext(this.onClickNext, c, this.props.labels.rightArrow), this.renderStatus()), this.renderThumbs());
    }
  }]), n;
}(p.default.Component);
q.default = Z;
l(Z, "displayName", "Carousel");
l(Z, "defaultProps", {
  ariaLabel: void 0,
  axis: "horizontal",
  centerSlidePercentage: 80,
  interval: 3e3,
  labels: {
    leftArrow: "previous slide / item",
    rightArrow: "next slide / item",
    item: "slide item"
  },
  onClickItem: L.noop,
  onClickThumb: L.noop,
  onChange: L.noop,
  onSwipeStart: function() {
  },
  onSwipeEnd: function() {
  },
  onSwipeMove: function() {
    return !1;
  },
  preventMovementUntilSwipeScrollTolerance: !1,
  renderArrowPrev: function(r, n, i) {
    return /* @__PURE__ */ p.default.createElement("button", {
      type: "button",
      "aria-label": i,
      className: I.default.ARROW_PREV(!n),
      onClick: r
    });
  },
  renderArrowNext: function(r, n, i) {
    return /* @__PURE__ */ p.default.createElement("button", {
      type: "button",
      "aria-label": i,
      className: I.default.ARROW_NEXT(!n),
      onClick: r
    });
  },
  renderIndicator: function(r, n, i, e) {
    return /* @__PURE__ */ p.default.createElement("li", {
      className: I.default.DOT(n),
      onClick: r,
      onKeyDown: r,
      value: i,
      key: i,
      role: "button",
      tabIndex: 0,
      "aria-label": "".concat(e, " ").concat(i + 1)
    });
  },
  renderItem: function(r) {
    return r;
  },
  renderThumbs: function(r) {
    var n = p.Children.map(r, function(i) {
      var e = i;
      if (i.type !== "img" && (e = p.Children.toArray(i.props.children).find(function(a) {
        return a.type === "img";
      })), !!e)
        return e;
    });
    return n.filter(function(i) {
      return i;
    }).length === 0 ? (console.warn("No images found! Can't build the thumb list without images. If you don't need thumbs, set showThumbs={false} in the Carousel. Note that it's not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md"), []) : n;
  },
  statusFormatter: L.defaultStatusFormatter,
  selectedItem: 0,
  showArrows: !0,
  showIndicators: !0,
  showStatus: !0,
  showThumbs: !0,
  stopOnHover: !0,
  swipeScrollTolerance: 5,
  swipeable: !0,
  transitionTime: 350,
  verticalSwipe: "standard",
  width: "100%",
  animationHandler: "slide",
  swipeAnimationHandler: K.slideSwipeAnimationHandler,
  stopSwipingHandler: K.slideStopSwipingHandler
});
var et = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "Carousel", {
    enumerable: !0,
    get: function() {
      return r.default;
    }
  }), Object.defineProperty(t, "CarouselProps", {
    enumerable: !0,
    get: function() {
      return n.CarouselProps;
    }
  }), Object.defineProperty(t, "Thumbs", {
    enumerable: !0,
    get: function() {
      return i.default;
    }
  });
  var r = e(q), n = et, i = e(k);
  function e(a) {
    return a && a.__esModule ? a : { default: a };
  }
})(de);
export {
  de as j
};
